import storage, { TOKEN_INFO } from '@shared/utils/storage'
import axios from 'axios'
// 判断各种浏览器 -全屏
export function launchFullScreen(element) {
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.webkitRequestFullScreen) {
    element.webkitRequestFullScreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  } else {
    this.$message('当前浏览器不支持部分全屏！')
  }
}
// 判断各种浏览器 -退出全屏
export function exitFullscreen(element) {
  console.log('exitFullscreen', element)
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}
export function getBlob(url, type) {
  return new Promise((resolve) => {
    axios(url, {
      method: 'get',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: `application/${type}` }))
      resolve(url)
    })
  })
}

export async function exportFile(name, blob_url, type = 'xlsx') {
  const filename = `${name}.${type}`
  const elink = document.createElement('a') // 创建a标签
  elink.download = filename // 为a标签添加download属性
  elink.style.display = 'none'
  if (blob_url instanceof Blob) {
    // 如果是blod
    elink.href = window.URL.createObjectURL(blob_url)
  } else {
    // 如果是url
    elink.href = await getBlob(blob_url, type)
  }

  document.body.appendChild(elink)
  elink.click() // 点击下载
  window.URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink) // 释放标签
}

/** 如果接口用的是blob2, 则用此方法 */
export async function exportFile2(filename, blob_url) {
  const elink = document.createElement('a') // 创建a标签
  elink.download = filename // 为a标签添加download属性
  elink.style.display = 'none'
  if (blob_url instanceof Blob) {
    // 如果是blod
    elink.href = window.URL.createObjectURL(blob_url)

    document.body.appendChild(elink)
    elink.click() // 点击下载
    window.URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink) // 释放标签
  }
}

/** 跳转到登录页 */
export const toLogin = () => {
  storage.clearStorage(TOKEN_INFO)
  import.meta.env.MODE === 'development'
    ? (window.location.href = import.meta.env.VITE_BASE_PATH + '/login')
    : (window.location.href = '/admin-main/login')
}

export const downloadFile = (url, fileName) => {
  console.log(url, fileName)
  // 1. 创建一个临时的 <a> 标签
  const link = document.createElement('a')

  // 2. 设置文件的 URL
  link.href = url

  // 3. 设置下载的文件名
  // 如果不设置 fileName，浏览器会尝试从 URL 中解析文件名，但通常最好显式设置。
  link.download = fileName || 'download'

  // 4. 将链接添加到 DOM 中（必须操作 DOM 才能模拟点击）
  document.body.appendChild(link)

  // 5. 模拟点击链接，触发下载
  link.click()

  // 6. 清理：移除临时创建的链接
  document.body.removeChild(link)
}
